import { createContext, useState } from 'react';
import api from 'services/api';

export const IndustrializacaoContext = createContext();

export const IndustrializacaoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [industrializacao, setIndustrializacao] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getIndustrializacao = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: industrializacao?.filter,
        page: industrializacao?.page,
        size: industrializacao?.size,
        order: industrializacao?.order,
        ...payload,
      });
      setIndustrializacao((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <IndustrializacaoContext.Provider
      value={{
        industrializacao,
        getLoading,
        getIndustrializacao,
      }}
    >
      {children}
    </IndustrializacaoContext.Provider>
  );
};
